var ajaxApp = {
    init: function () {
        this.grid.init();
        this.initFeedbackForm();
        this.initFooterSubscribe();
        this.initUserReviewForm();
    },
    // The legacy prAjaxGrid mechanism (JSON init-state + JS-rebuilt DOM for filters/grid/
    // pagination/calendar) has been fully replaced by htmx (see htmxListing.js and
    // frontend/views/listing/_grid.php, _cards.php, _calendar.php). No page renders a
    // [prAjaxGrid="true"] element anymore, so only the non-grid-specific tail of the old
    // grid.init() - customSelects()/app.filters(), both still needed unconditionally on
    // every page - remains here.
    grid: {
        init: function () {
            if (!app.isMobile()) {
                app.customSelects();
            }
            app.filters();
        },
    },
    initFooterSubscribe: function () {
        $(document).on('submit', '.footer-subscribe-form', function (e) {
            e.preventDefault();
            var $form = $(this);

            //app.setFormLoadingState($form, true);

            var method = $form.attr('method');
            var formData = $form.serialize();
            var endpoint = $form.attr('action');

            $.ajax({
                url: endpoint,
                method: method,
                data: formData,
                dataType: 'json',
                success: function (response) {
                    switch (response.status) {
                        case 'success':
                            if (response.redirectUrl) {
                                location.href = response.redirectUrl;
                            } else if (response.message) {
                                $('.main-footer__mailing').html(
                                    '<p class="sub-success-result">' + response.message + '</p>'
                                );
                            }
                            break;
                        case 'failed':
                            if (response.errors) {
                                $form.find('.footer-subscribe-form__title').hide();
                                buyModule.setFormValidateErrors($form, response.errors);
                            }
                            break;
                        default:
                            if (response.errors) {
                                $form.find('.footer-subscribe-form__title').hide();
                                buyModule.setFormValidateErrors($form, response.errors);
                            }
                    }

                    //app.setFormLoadingState($form, false);
                }
            });
        });
    },
    initFeedbackForm: function () {
        $(document).on('submit', '.feedback-form__form', function (e) {
            e.preventDefault();
            let $form = $(this);
            const $formSuccessWindow = $form.next('.form-success-window');

            app.setFormLoadingState($form, true);

            const method = $form.attr('method');
            const endpoint = $form.attr('action');

            if (typeof grecaptcha !== "undefined") {
                grecaptcha.execute(window.jsConfig.frontSecret, { action: 'submit' }).then(function (token) {
                    $form.find('#feedback-captcha').val(token);

                    $.ajax({
                        url: endpoint,
                        method: method,
                        data: $form.serialize(),
                        dataType: 'json',
                        success: function (response) {
                            switch (response.status) {
                                case 'success':
                                    if (response.redirectUrl) {
                                        location.href = response.redirectUrl;
                                    } else {
                                        if ($formSuccessWindow.length > 0) {
                                            $formSuccessWindow.show();
                                            $form[0].reset();
                                            $form.hide();
                                        }
                                    }
                                    break;
                                case 'error':
                                    buyModule.setFormValidateErrors($form, response.errors);
                                    break;
                            }
                        }
                    });
                });
            }
            app.setFormLoadingState($form, false);
        });

        $(document).on('click', '.form-success-window__close', function(e) {
            var $corrForm = $(this).closest('.form-success-window').prev('form');
            if ($corrForm.length > 0) {
                $corrForm.show();
                $(this).closest('.form-success-window').hide();
            }
        });
    },
    initUserReviewForm: function () {
        $(document).on('click', '#btn-user-review-show-form', function (e) {
            if (!app.isUserAuthorized()) {
                let notAuthorizedTipUserReview = $('.not-authorized-tip-user-review');
                notAuthorizedTipUserReview.fadeIn(1000);

                let userAccountTextAuthWrapper = $('.user-account-text-auth-wrapper');
                if (userAccountTextAuthWrapper.length) {
                    userAccountTextAuthWrapper.click();
                }
            } else {
                $('#user-review-form').removeClass('hidden');
                $('#btn-user-review-show-form').addClass('hidden');
                $('.close-user-review-form').removeClass('hidden');
            }
        });

        $(document).on('click', '.close-user-review-form', function (e) {
            $('#user-review-form').addClass('hidden');
            $(this).addClass('hidden');
            $('#btn-user-review-show-form').removeClass('hidden');
        });

        $(document).on('submit', '#user-review-form', function (e) {
            e.preventDefault();
            let $form = $(this);
            const $formSuccessWindow = $form.next('.form-success-window');

            app.setFormLoadingState($form, true);

            const method = $form.attr('method');
            const endpoint = $form.attr('action');

            if (typeof grecaptcha !== "undefined") {
                grecaptcha.execute(window.jsConfig.frontSecret, { action: 'submit' }).then(function (token) {
                    $form.find('#user-review-form-captcha').val(token);

                    $.ajax({
                        url: endpoint,
                        method: method,
                        data: $form.serialize(),
                        dataType: 'json',
                        success: function (response) {
                            switch (response.status) {
                                case 'success':
                                    if (response.redirectUrl) {
                                        location.href = response.redirectUrl;
                                    } else {
                                        if ($formSuccessWindow.length > 0) {
                                            $formSuccessWindow.show();
                                            $form[0].reset();
                                            $form.hide();
                                        }
                                    }
                                    break;
                                case 'error':
                                    buyModule.setFormValidateErrors($form, response.errors);
                                    break;
                            }

                            app.setFormLoadingState($form, false);
                        }
                    });
                });
            }
        });
    },
};

$("document").ready(function () {
    ajaxApp.init();
});
